import { Component, Input } from "@angular/core";

import { SizeGuide } from "@hermes/api-model-product";

@Component({
    selector: "h-size-guide",
    templateUrl: "./size-guide.component.html",
    styleUrls: ["./size-guide.component.scss"],
})
export class SizeGuideComponent {
    @Input({ required: true })
    public content!: SizeGuide;
}
